import PipelineStateIcon, {
  colorForJob,
} from "~/components/shared/PipelineStateIcon/PipelineStateIcon";
import { Job } from "~/components/build/Show/lib/types";
import classNames from "classnames";
import { useBuild } from "~/components/build/Show/lib/BuildContext";
import { sortJobsByState } from "~/components/build/Show/lib/sortJobsByState";

export function State({ job }: { job: Job }) {
  const { build } = useBuild();

  return (
    <PipelineStateIcon
      job={job}
      className={classNames("block h-4 w-4", colorForJob(job, build))}
      style={{ width: undefined, height: undefined }}
    />
  );
}

export const sortByState = sortJobsByState;
